import instance from 'utils/axios/instance.axios';
import { PROJECTS } from './_constant';

// eslint-disable-next-line import/prefer-default-export
export const getAllProjectStatus = () => instance.get(PROJECTS.GET_ALL_PROJECT_STATUS);
export const getAllProject = (pagination, filters, showMode) =>
  instance.get(PROJECTS.GET_ALL, { params: { ...pagination, ...filters, showMode } });

export const createContract = (data) => instance.post(PROJECTS.POST_CREATE, data);

export const submitContract = (id) => instance.post(PROJECTS.SUBMIT_CONTRACT(id));

export const uploadContractFiles = (data) =>
  instance.post(PROJECTS.POST_UPLOAD_PROJECT_FILES, data);

export const deleteContractFiles = (body = {}) =>
  instance.post(PROJECTS.POST_DELETE_PROJECT_FILES, body);

export const getProjectById = (id) => instance.get(PROJECTS.GET_PROJECT_BY_ID(id));
export const getProjectByProjectProposalId = (projectProposalId) =>
  instance.get(PROJECTS.GET_PROJECT_BY_PROJECT_PROPOSAL_ID(projectProposalId));

export const deleteProject = (id) => instance.delete(PROJECTS.DELETE_PROJECT(id));

export const restoreProject = (id) => instance.patch(PROJECTS.RESTORE_PROJECT(id));

export const downloadPdfFile = (id) =>
  instance.get(PROJECTS.GET_PDF_FILE(id), { responseType: 'blob' });

export const downloadFile = (body) =>
  instance.post(PROJECTS.POST_DOWNLOAD_PDF, body, { responseType: 'blob' });

export const downloadDocxFile = (id) =>
  instance.get(PROJECTS.GET_DOCX_FILE(id), { responseType: 'blob' });

export const downloadDocxByTemplateFile = (id) =>
  instance.get(PROJECTS.GET_DOCX_BY_TEMPLATE(id), { responseType: 'blob' });

export const exportExcel = (data = {}) =>
  instance.post(PROJECTS.EXPORT_EXCEL, data, { responseType: 'blob' });

export const getGeneralInfoProjectForCouncil = (id) =>
  instance.get(PROJECTS.GET_GENERAL_INFO_FOR_COUNCIL(id));

export const getGeneralInfoForCouncilById = (id) =>
  instance.get(PROJECTS.GET_GENERAL_INFO_FOR_COUNCIL(id));

export const getProjectSumUp = (id) => instance.get(PROJECTS.SUM_UP(id));

export const editHumanResource = ({ projectProposalId, ...body }) =>
  instance.post(PROJECTS.POST_HUMAN_RESOURCE(projectProposalId), body);

export const getAttachment = (id) => instance.get(PROJECTS.GET_ATTACHMENT(id));

export const getAdjustmentsById = (id) => instance.get(PROJECTS.GET_ADJUSTMENTS_BY_ID(id));

export const downloadDocxHumanResourceFile = (id) =>
  instance.post(PROJECTS.DOWNLOAD_DOCX_HUMAN_RESOURCE_FILE(id), { responseType: 'blob' });
export const downloadDocxTemplateHumanResourceFile = (id) =>
  instance.post(PROJECTS.DOWNLOAD_DOCX_TEMPLATE_HUMAN_RESOURCE_FILE(id), { responseType: 'blob' });
export const downloadPdfHumanResourceFile = (id) =>
  instance.post(PROJECTS.DOWNLOAD_PDF_HUMAN_RESOURCE_FILE(id), { responseType: 'blob' });
export const downloadPdfTemplateHumanResourceFile = (id) =>
  instance.post(PROJECTS.DOWNLOAD_PDF_TEMPLATE_HUMAN_RESOURCE_FILE(id), { responseType: 'blob' });

export const getDataForRegisterResult = (projectId, councilType) =>
  instance.get(PROJECTS.GET_DATA_FOR_REGISTER_RESULT(projectId), {
    params: { councilType },
  });
